import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { Provider, ProviderType, TrackingEvent } from '../types';

interface PepperjamConfig {
  containerId: string;
  isEnabled?: boolean;
}

// Window interface已在index.d.ts中统一定义

export class PepperjamProvider implements Provider {
  type = ProviderType.PEPPERJAM;
  isEnabled: boolean;
  loggingEnabled = false; // 公开属性，支持ReportingCenter访问
  private initialized = false;
  private config: PepperjamConfig;

  constructor(config: PepperjamConfig) {
    this.config = config;
    this.isEnabled = config.isEnabled ?? true;
    this.loggingEnabled = env.NEXT_PUBLIC_ENV === 'local';
  }

  async init(): Promise<boolean> {
    try {
      if (typeof window === 'undefined') return false;
      if (this.initialized) return true;

      // Initialize Pepperjam tracking using the original script logic
      // 为了减小对TBT的影响，把其加载的时序再往后延
      setTimeout(() => {
        // Replicate the original Pepperjam script
        const a = document.createElement('script');
        a.type = 'text/javascript';
        a.async = true;
        a.src = `//container.pepperjam.com/${this.config.containerId}.js`;

        a.onload = () => {
          if (this.loggingEnabled) {
            logger.log('Pepperjam: Script loaded successfully');
          }
        };

        a.onerror = () => {
          if (this.loggingEnabled) {
            logger.error('Failed to load Pepperjam script');
          }
        };

        // Try to append to head first, fallback to inserting before first script
        const head = document.getElementsByTagName('head')[0];
        if (head) {
          head.appendChild(a);
        } else {
          const firstScript = document.getElementsByTagName('script')[0];
          if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(a, firstScript);
          } else {
            // Fallback: append to document body
            document.body.appendChild(a);
          }
        }
      }, 5000);
      this.initialized = true;
      return true;
    } catch (error) {
      logger.error('Failed to initialize Pepperjam:', error);
      return false;
    }
  }

  track(event: TrackingEvent): void {
    if (!this.initialized || typeof window === 'undefined') return;

    try {
      if (this.loggingEnabled) {
        logger.log('Pepperjam tracking event:', event);
      }
      // 暂时为空，没有在主站看到有使用的地方
    } catch (error) {
      logger.error('Pepperjam tracking error:', error);
    }
  }

  /**
   * 启用Pepperjam日志
   */
  enableLog(): void {
    this.loggingEnabled = true;
  }

  /**
   * 禁用Pepperjam日志
   */
  disableLog(): void {
    this.loggingEnabled = false;
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}
